import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { useEffect, useRef } from "react";
import { useProfile } from "../../context/ProfileContext";
import api from "../../utils/api";
import { apiUrls } from "../../utils/urls";

export default function VerifyEmailDialog({ ...props }) {
  const linkSentDate = useRef(null);
  const { profile } = useProfile();

  const sendEmail = async () => {
    await api.post(apiUrls.users.emailVerificationLink(), {
      redirect_url: window.location.toString(),
    });
  };
  useEffect(() => {
    const resendLink =
      linkSentDate.current == null ||
      (new Date() - linkSentDate.current) / 1000 >= 60;

    if (resendLink && props.open) {
      linkSentDate.current = new Date();
      sendEmail();
    }
  }, [props]);

  return (
    <Dialog {...props}>
      <DialogTitle>Verification Email Sent!</DialogTitle>
      <DialogContent>
        <Typography variant="body1">
          An email verification link has been emailed to you at{" "}
          <span style={{ fontWeight: "bold" }}>{profile?.user.email}</span>.
        </Typography>
        <br />
        <Typography variant="body1">
          Once you have visited that link, refresh your profile for the changes
          to take effect!
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button type="submit" onClick={props.onClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
